import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bfb54526"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bfb54526&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfb54526')) {
      api.createRecord('bfb54526', component.options)
    } else {
      api.reload('bfb54526', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bfb54526", function () {
      api.rerender('bfb54526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TransformSpecialCode/index.vue"
export default component.exports